import UpgradedReport from './UpgradedReport.component';

export default UpgradedReport;
